export default __webpack_public_path__ + "static/media/logo-ecoe-no-char.9374300f.svg";